<div class="ziro-admin-page-content">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
  <div class="col-md-10 offset-md-1" [hidden]="isLoading">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item [aboutCardId]="42"></ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>

    @if (!isLoading) {
      <div>
        <ziro-datatable
          [rowDataSource]="data"
          [columns]="columns"
          [uniqueRowIdentifier]="'name'"
          [dataAutomation]="tableAutomationId"
          [showCustomAlert]="true"
          [class]="'ziro-card'"
        >
          <ziro-datatable-multi-select-filter
            [label]="'tkey;admin.ms_dial_plan_exception.group_type.label'"
            [items]="typeFilterOptions"
            [matchFn]="isTypeMatch"
            [dataAutomation]="'type-filter'"
            [tableId]="tableAutomationId"
          ></ziro-datatable-multi-select-filter>
          <div
            alert-content
            [innerHtml]="'tkey;admin.ms_dial_plan_exception.list.no_results' | escapeHtml: {
            url: `#/admin/tenants/${this.tenantInfo?.tenantId}/dial-plan-exception-management/dial-plan-exception-group`
        }"
          ></div>
        </ziro-datatable>
      </div>
    }
  </div>
</div>

<ziro-bottom-nav></ziro-bottom-nav>
